import {
  secondaryRebrandTheme,
  type ThemeType,
} from 'radiance-ui/lib/constants';

import type { Brand } from 'jsx/utils/brand';

/**
 * The `__type` value radiance-ui assigns to the Agency rebrand theme
 * (`secondaryRebrandTheme`). All Agency rebrand styling keys off this value so
 * Curology (`primary`) and flag-off Agency (`secondary`) remain unaffected.
 */
export const AGENCY_REBRAND_THEME_TYPE = secondaryRebrandTheme.__type;

export const isAgencyRebrand = (theme: ThemeType): boolean =>
  theme.__type === AGENCY_REBRAND_THEME_TYPE;

/**
 * Whether this patient's UI should use the Agency rebrand (green) palette.
 * Callers pass the LaunchDarkly `agency-rebrand` evaluation (or the
 * patient-site `window.AGENCY_REBRAND_ENABLED` equivalent).
 */
export const isAgencyRebrandPaletteEnabled = (
  brand: Brand,
  isRebrandFlagOn: boolean,
): boolean => brand.isAgency && isRebrandFlagOn;

export const getAgencyPaletteTheme = (
  brand: Brand,
  isRebrandFlagOn: boolean,
): ThemeType =>
  isAgencyRebrandPaletteEnabled(brand, isRebrandFlagOn)
    ? secondaryRebrandTheme
    : brand.theme;
